//=====================================================================
// Sort the trigger types into seperate arrays
//=====================================================================
//export const sortTriggerTypes = (triggerArray, triggerType) => {
//    return triggerArray.filter(trigger => trigger.getAttribute('data-tooltip') === triggerType)
//};


// Create an element (div, ul, li, span) with classes and/or attributes
export function createElement(element, classes = [], attributes = []) {
    const newElement = document.createElement(element);
    classes.forEach(className => newElement.classList.add(className));
    for (let att in attributes) {
        newElement.setAttribute(att, attributes[att]);
    }
    return newElement;
}


// Debounce Function
export function debounce(func, wait) {
    let timeout;
    return function(...allArgumentsForFunction) {
        const later = () => {
            clearTimeout(timeout);
            func(...allArgumentsForFunction); // Call the original function with the collected arguments
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
}